import { render } from "./CreateView.vue?vue&type=template&id=633d47fe&scoped=true"
import script from "./CreateView.vue?vue&type=script&lang=js"
export * from "./CreateView.vue?vue&type=script&lang=js"

import "./CreateView.vue?vue&type=style&index=0&id=633d47fe&lang=css"
import "./CreateView.vue?vue&type=style&index=1&id=633d47fe&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-633d47fe"]])

export default __exports__